"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoDisplayWrapper = InfoDisplayWrapper;
exports.getInfoDisplayWrapperProps = getInfoDisplayWrapperProps;
var _react = _interopRequireDefault(require("react"));
var _FlexColumn = require("../../components/layout/flex/FlexColumn");
var _FlexRow = require("../../components/layout/flex/FlexRow");
var _Label = _interopRequireDefault(require("../../components/text/Label"));
var _Text = _interopRequireDefault(require("../../components/text/Text"));
var _IconTooltip = _interopRequireDefault(require("../../components/feedback/tooltip/IconTooltip"));
var _jsxRuntime = require("react/jsx-runtime");
/**
 * All controls in our design system should have a label, help text, and error text. Some of the aria hooks output label props (useDatePicker generates an onClick event that
 * focuses the first date segment for example. This wrapper component takes care of that and also provides a consistent layout for all controls.
 * */

function getInfoDisplayWrapperProps(props) {
  return {
    label: props.label,
    ariaLabelProps: props.ariaLabelProps,
    isOptional: props.isOptional,
    helperText: props.helperText,
    ariaHelpTextProps: props.ariaHelpTextProps,
    errorText: props.errorText,
    showErrorAsIconTooltip: props.showErrorAsIconTooltip,
    ariaErrorTextProps: props.ariaErrorTextProps,
    'data-cy': props['data-cy'],
    children: props.children
  };
}
function InfoDisplayWrapper(_ref) {
  var label = _ref.label,
    ariaLabelProps = _ref.ariaLabelProps,
    isOptional = _ref.isOptional,
    helperText = _ref.helperText,
    ariaHelpTextProps = _ref.ariaHelpTextProps,
    errorText = _ref.errorText,
    showErrorAsIconTooltip = _ref.showErrorAsIconTooltip,
    ariaErrorTextProps = _ref.ariaErrorTextProps,
    dataCy = _ref['data-cy'],
    children = _ref.children,
    fixedWidth = _ref.fixedWidth;
  var showErrorTextAsIcon = Boolean(errorText && showErrorAsIconTooltip);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexColumn.FlexColumn, {
    flex: fixedWidth ? '0' : '1',
    children: [label || showErrorTextAsIcon ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
      alignItems: 'center',
      children: [label ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Label.default, _objectSpread({
        isOptional: isOptional
      }, ariaLabelProps, {
        "data-cy": dataCy ? "".concat(dataCy, "-label") : undefined,
        children: label
      })) : undefined, showErrorTextAsIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconTooltip.default, {
        icon: 'warning',
        iconSize: 'm',
        iconColor: 'error',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, _objectSpread({}, ariaErrorTextProps, {
          children: errorText
        }))
      }) : null]
    }) : undefined, helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, _objectSpread({}, ariaHelpTextProps, {
      color: _Text.default.Color.auxiliary
    }, ariaLabelProps, {
      "data-cy": dataCy ? "".concat(dataCy, "-helper-text") : undefined,
      children: helperText
    })) : undefined, children, errorText && !showErrorAsIconTooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, _objectSpread({}, ariaErrorTextProps, {
      color: _Text.default.Color.error,
      "data-cy": dataCy ? "".concat(dataCy, "-error") : undefined,
      children: errorText
    })) : null]
  });
}